import { useCallback, memo } from 'react';
import classNames from 'classnames';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  tooltipItemWrapper: {
    cursor: 'pointer',
  },
  tooltipItemWrapperDisabled: {
    cursor: 'default',
  },
}));

const VirtualItem = ({
  item,
  renderLabelItem,
  labelComponentProps,
  labelComponent: Item,
  isAccessible,
  onItemClickHandler,
}) => {
  const classes = useStyles();

  const handleClick = useCallback(
    e => {
      if (isAccessible) {
        e.preventDefault();
        e.stopPropagation();
        onItemClickHandler(item.id);
      } else {
        e.stopPropagation();
      }
    },
    [isAccessible, item.id, onItemClickHandler]
  );

  return (
    <div
      className={classNames(classes.tooltipItemWrapper, {
        [classes.tooltipItemWrapperDisabled]: !isAccessible,
      })}
      onClick={handleClick}
    >
      {Item ? (
        <Item
          data={item}
          {...labelComponentProps}
          isAccessible={isAccessible}
        />
      ) : (
        renderLabelItem(item, isAccessible)
      )}
    </div>
  );
};

VirtualItem.propTypes = {};

export default memo(VirtualItem);
